import { extractErrorMessage } from "./extract-error-message"

const _re1 = /"message":"([\w\s:_+!?\,\.-]+)/i
const _re2 = /^([\w\s_\-.,]+):(.*)$/s

export const extractContractError = (error: unknown, fallback = "Unknown Error") => {
  const _error = extractErrorMessage(error)
  const _message = _error.match(_re1)
  const message = _message?.[1] || _error

  const _titleContent = message.match(_re2)
  const title = _titleContent?.[1] || fallback
  const content = _titleContent?.[2] || message

  return { message, title, content }
}
